import React, { useEffect, useMemo, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaTimes } from "react-icons/fa";
import CommonTable from "../../components/CommonTable/CommonTable";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import "./UserDetails.css";
import moment from "moment/moment";
import usePermission from "../../customHook/usePermission";
import StatusModal from "../../components/StatusModal/StatusModal";

const Users = () => {
  const location = useLocation();
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(location?.state?.page || 1);
  const [searchText, setSearchText] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState(null);
  const [address, setAddress] = useState('')
  const [popup, setPopup] = useState(false);
  const navigate = useNavigate();
  const permission = usePermission();

  const pageRef = useRef(page);

  // keep pageRef in sync with the latest page
  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  // clear state after using it (run only once when component mounts)
  useEffect(() => {
    if (location?.state?.page) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);
  console.log("pageRef.current", pageRef.current);

  const handleView = async (row) => {
    console.log("ROW DATA:", row);

    if (row?.id) {
      navigate("/users-view", {
        state: { id: row?.id, page: pageRef.current },
      });
    }
  };

  const handleStatusView = async (row) => {

    if (row?.id) {
      const res = await get(`${URLS.USERADDRESS}${row?.id}/`);
      console.log("resadders", res);
      if (res?.status === 'success') {
        setAddress(res);
        setPopup(true);
      }

    }
  }

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "sno",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return (
            <span className="sno">
              {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
            </span>
          );
        },
      },
      {
        Header: "User Name",
        accessor: "name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "User Type",
        accessor: "user_type",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Mobile Number",
        accessor: "mob_no",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Registration Date",
        accessor: "created_at",
        width: "70%",
        Cell: ({ value }) => {
          return (
            <p className="mb-0">
              {value ? moment(value).format("DD-MM-YYYY") : "N/A"}
            </p>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        width: "70%",
        Cell: ({ value, row }) => {
          return (
            <>
              {permission?.includes("CAN-STATUS-USERS") && (
                <p
                  // onClick={() => handleStatusChange(row?.original)}
                  className="mb-0"
                  style={{
                    color: value === "Active" ? "green" : "red",
                    border:
                      value === "Active" ? "1px solid green" : "1px solid red",
                    fontWeight: 500,
                    padding: "5px 10px",
                    borderRadius: "5px",
                    textAlign: "center",
                    width: "120px",
                    cursor: "default",
                  }}
                >
                  {value === "User Deleted" ? "De Active" : value || "Unknown"}
                </p>
              )}
            </>
          );
        },
      },
    ];

    let textaction = {
      Header: "Last Demand At",
      accessor: "textaction",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {permission?.includes("CAN-VIEW-USERS") && (
              <button
                className="action-btn"
                onClick={() => handleStatusView(row?.original)}
              >
                <FaEye />
              </button>
            )}
          </>
        );
      },
    };

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {permission?.includes("CAN-VIEW-USERS") && (
              <button
                className="action-btn"
                onClick={() => handleView(row?.original)}
              >
                <FaEye />
              </button>
            )}
          </>
        );
      },
    };

    return [...d, textaction, action];
  }, [page]);

  const handleClearSearch = () => {
    setSearchText("");
    setPage(1);
  };

  const fetchUsers = async () => {
    try {
      let res = await get(
        `${URLS.USERLIST}?page=${page || 1}&search=${searchText || ""}`
      );
      console.log("Users list res:", res);
      if (res?.status === "success") {
        setUsers(res?.data || []);
        setTotalCount(res?.count || 0);
        setPagination({
          current_page: res?.current_page || 1,
          last_page: res?.total_pages || 1,
        });
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [page, searchText]);

  return (
    <>
      <PageHeader title="Users" />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
          Total: {totalCount || 0}
        </h2>
        <div className="search-wrapper">
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchText || ""}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
          />
          {searchText && (
            <FaTimes
              className="search-clear-icon"
              onClick={handleClearSearch}
            />
          )}
        </div>
      </div>
      <CommonTable
        columns={columns}
        data={users || []}
        pagecount={pagination}
        setPageno={setPage}
        pageno={page || 1}
      />
      <StatusModal isOpen={popup} onClose={() => setPopup(false)} message={address?.address} time={address?.last_click_update} />
    </>
  );
};

export default Users;
